<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--점검정보-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검정보</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer mt-4">
      <div>
        <div>점검일</div>
        <span v-if="isPrint" class="print-input"> {{ form.inputA_1 }} </span>
        <date-selector v-else class="w-full flex-1" v-model="form.inputA_1" :readonly="board.readonly" />
      </div>
      <div>
        <div>점검장소</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
        <ml-input v-else v-model="form.inputA_2" class="w-full flex-1" :readonly="board.readonly" />
      </div>
      <div>
        <div>면적</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
        <comma-input v-else v-model="form.inputA_4" type="number" class="w-full flex-1" :readonly="board.readonly" />
        <p class="pl-2">m<sup>2</sup></p>
      </div>
      <div>
        <div>층수 (지하/지상)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_5 }} / {{ form.inputA_6 }}</p>
        <div v-else class="flex items-center gap-3">
          <ml-input v-model="form.inputA_5" :readonly="board.readonly" />
          <span>/</span>
          <ml-input v-model="form.inputA_6" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>점검대상 건물용도</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_7 }}</p>
        <ml-input v-else v-model="form.inputA_7" class="w-full flex-1" :readonly="board.readonly" />
      </div>

      <div>
        <div>점검자</div>
        <p v-if="isPrint" class="print-input">소속 : {{ form.inputA_8 }} / 성명 : {{ form.inputA_9 }}</p>
        <div v-else class="flex items-center gap-4">
          <span>소속</span>
          <ml-input v-model="form.inputA_8" class="w-full flex-1" :readonly="board.readonly" />
          <span>성명</span>
          <ml-input v-model="form.inputA_9" class="w-full flex-1" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>점검여부</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_10 }}</p>
        <label v-else class="flex items-center"> <vs-checkbox v-model="form.inputA_10" vs-value="이행" :readonly="board.readonly" /> 이행 </label>
      </div>
    </div>

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검대상</h5>
      </vs-col>
    </vs-row>
    <div class="grid xl:grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center" v-for="checkbox in form.inspectList" v-bind:key="checkbox.id">
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <div v-for="(inspection, indexRows) in form.inspectList" v-bind:key="inspection.id">
      <table-inspect
        class="mt-8"
        v-bind:key="inspection.id"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :title="inspection.title"
        :list="inspection.list"
        :isNotDotInLabel="false"
        :is-note="true"
        :is-bottom-note="true"
        table-header-title="점검사항"
        header-width-yes="80px"
        table-header-yes="양호"
        table-header-no="미흡"
        header-width-no="80px"
        table-header-na="해당없음"
        header-width-na="80px"
        table-header-note="비고(보완계획)"
        bottom-note-title="기타 점검의견"
        :init-bottom-note="inspection.note"
        @update-list-check="
          (param1, param2) => {
            updateListCheck(indexRows, param1, param2);
          }
        "
        @update-bottom-note="
          (text) => {
            updateBottomNote(indexRows, text);
          }
        "
        v-if="inspection.check"
      />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-8" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploader from "@/components/FileUploader";
import TableInspectEp from "@/components/TableInspectCustomEp";
import TableEtcCheck from "@/components/TableEtcCheck";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import TableInspect from "@/components/TableInspect";

export default {
  components: {
    TableInspect,
    DisasterClassSelector,
    TimeSelector,
    DateSelector,
    CustomOptionSelector,
    TableEtcCheck,
    TableInspectEp,
    FileUploader,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;

        value.summary = {
          시설물점검_게시글: [{ "위탁시설물 안전종합점검 이행": 1 }],
          시설물점검_사업장명: [],
          시설물점검_사업장주소: [],
          시설물점검_사업장구분: [],
          시설물점검_점검결과: [],
        };
        let checkCount = 0;
        for (const inspect of this.form.inspectList) {
          if (inspect.check) {
            checkCount++;
            value.summary["시설물점검_점검결과"].push({
              [inspect.title]: 1,
            });
          }
        }
        if (this.form.stdInfo.field_name) {
          value.summary["시설물점검_사업장명"].push({
            [this.form.stdInfo.field_name]: checkCount,
          });
        }
        if (this.form.stdInfo.field_address) {
          value.summary["시설물점검_사업장주소"].push({
            [this.form.stdInfo.field_address]: checkCount,
          });
        }
        if (this.form.stdInfo.facility_category && this.form.stdInfo.facility_category.cat1) {
          value.summary["시설물점검_사업장구분"].push({
            [this.form.stdInfo.facility_category.cat1]: checkCount,
          });
        }
        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = [];
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label);
        }
      }
    },
    updateListCheck(indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text;
    },
    updateBottomNote(indexList, text) {
      this.form.inspectList[indexList].note = text;
    },

    updateEtcListCheck(row, text) {
      this.form.etcList[row].checked = text;
    },
    updateListNote(row, text) {
      this.form.etcList[row].note = text;
    },
    updateList(list) {
      this.form.etcList = list;
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inputA_1: "",
        inputA_2: "",
        inputA_3: [],
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",
        inputA_10: "",

        inputC_1: {},
        inputC_2: "",

        typeTitleList: [],
        inspectList: [],
        photoList: [],
        fileList: [],
        etcList: [],
      },
    };
  },
  computed: {
    inspectTable() {
      return [
        {
          id: 1,
          label: "안전관리체계 구축",
          check: false,
          title: "안전관리체계 구축",
          note: "",
          list: [
            {
              id: 1,
              label: "필요한 안전인력 확보",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "필요한 안전예산 편성 및 집행",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "안전점검 계획 수립 및 수행",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "안전계획 수립 및 이행",
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: "재해예방 업무처리절차 마련 및 이행",
              is_checked: "",
              note: "",
            },
            {
              id: 6,
              label: "도급용역위탁 기준과 절차 마련 및 이행",
              is_checked: "",
              note: "",
            },
            {
              id: 7,
              label: "안전교육 실시 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 8,
              label: "안전보건 표지의 설치 및 부착",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 2,
          label: "건축구조",
          check: false,
          title: "건축구조",
          note: "",
          list: [
            {
              id: 1,
              label: "피난시설 규정 등 건축법상 저촉여부",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: `지반이 침하되어 있는 곳은 없는가?
              - 건물 주변 지반의 단차 및 균열이 없어야 함
              - 건물 인근의 지하수 누출 없어야 함`,
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: `건물이 기울어져 있지는 않은가?
              - 바닥은 기울이지 않고 창문은 원활하게 개폐되어야 함
              - 외벽은 수직상태를 유지하여야 함`,
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: `균열은 없는가?
              - 구조체(기둥,보,슬래브,내력벽)에 균열 없어야 함`,
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: `철근노출 및 부식, 박리, 박락된 곳은 없는가?
              - 철근 노출 및 콘크리트가 떨어지거나 들뜨지 않아야 함`,
              is_checked: "",
              note: "",
            },
            {
              id: 6,
              label: `구조체 단면손상 및 하중이 증가된 부분은 없는가?
              - 기둥,보,슬래브,내력벽의 설계 단면 손상이 없어야 함
              - 지붕 및 건물 내에 설계도에 없는 구조물,탱크 등 설치는 없어야 함.`,
              is_checked: "",
              note: "",
            },
            {
              id: 7,
              label: `철골재의 볼트체결 상태는 적정한가?
              - 접합부 볼트 누락 및 체결부위에 틈새 발생 없어야 함
              - 접합부 용접은 적합하게 시행 하여야 함`,
              is_checked: "",
              note: "",
            },
            {
              id: 8,
              label: `철골재 건축물이 손상된 곳은 없는가?
              - 철재의 부식으로 단면결손 및 도장 탈락 없어야 함
              - 기둥,보,슬래브의 휨, 처짐 등 손상 없어야 함
              - 철골 구조물의 구조내력 저하여부`,
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 3,
          label: "건축마감",
          check: false,
          title: "건축마감",
          note: "",
          list: [
            {
              id: 1,
              label: `지붕,옥상 마감은 적정한가?
              - 난간의 높이가 1.2m 이상이며, 난간살 기준에 적합하게 튼튼하게 설치하여야 함
              - 지붕 마감재의 탈락, 옥상에 비산 우려 물체가 없어야 함
              - 배수구멍의 걸림망 설치 및 기능 발휘에 문제 없어야 함
              - 방수층의 손상 및 잡초의 식생 없어야 함`,
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: `내외부 마감재는 적합하게 설치되어 있는가?
              - 탈락,들뜸,추락의 위험이 없어야 함
              - 계단에 미끄럼방지시설 설치히여야 함
              - 내부 마감재는 과도한 변이가 없어야 함`,
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: `환기구 덮개,점검로 상태는 적정한가?
              - 환기구 등 덮개는 변형,부식 등이 없어야 함
              - 점검로 또는 점검사다리는 변형, 부식이 없어야 함`,
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "담장,축대 등 부대시설의 안전성 여부",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 4,
          label: "전기분야",
          check: false,
          title: "전기분야",
          note: "",
          list: [
            {
              id: 1,
              label: "누전차단기 등 전기시설의 정상적동 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: `전기안전관리 이행 여부
              - 일상,정기,정밀(연차) 점검 등 법정검사 수검이행(위탁시 갈음)
              - 전기실, 배전실 등 위험한 장소에 위험표지 설치`,
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "법정검사(사용전검사, 정기검사)수검 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "전기기계,기구 등으로 인한 위험 방지 조치",
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: "전선 배선불량 및 문어발식 콘센트 사용여부",
              is_checked: "",
              note: "",
            },
            {
              id: 6,
              label: "조명탑 등 전기시설물의 유지관리 상태",
              is_checked: "",
              note: "",
            },
            {
              id: 7,
              label: `정전기 및 낙뢰로 인한 재해 예방 조치 등
              - 정전기로 인한 화재 폭발 방지
              - 피뢰설비의 설치 등`,
              is_checked: "",
              note: "",
            },
            {
              id: 8,
              label: "승강기 등 안전관리 및 작동상태",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 5,
          label: "가스분야",
          check: false,
          title: "가스분야",
          note: "",
          list: [
            {
              id: 1,
              label: "가스용기 관리실태 및 가연성 물질 방치여부",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "가스차단기, 경보기 등 정상작동 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "가스기기 이용실태 및 시설기준 적정여부",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "가스보일러의 흡·배기구시설 설치상태",
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: "지하실 환기 및 관리상태 확인",
              is_checked: "",
              note: "",
            },
            {
              id: 6,
              label: "가스밸브 노후여부, 배관매설, 고정상태",
              is_checked: "",
              note: "",
            },
            {
              id: 7,
              label: "가스사용 시, 주의사항 등 안전표어 부착여부",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 6,
          label: "소방분야",
          check: false,
          title: "소방분야",
          note: "",
          list: [
            {
              id: 1,
              label: "내부마감재 방염기준 등의 적법여부",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "소화기, 화재탐지기 등 소방시설 상태",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "위험물질 및 화기관리의 적정성 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "방화문, 방화샷터의 정상작동상태 점검",
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: "피난, 소화통로 확보여부, 유지관리 상태",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 7,
          label: "차량 및 기타 안전일반 분야",
          check: false,
          title: "차량 및 기타 안전일반 분야",
          note: "",
          list: [
            {
              id: 1,
              label: "차량의 운행 전후로 브레이크,트랙 등 차량점검 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "차량 운행자에게 안전운전에 대한 교육이 적절히 이루어지고 있는지 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "차량 내 소화기,비상용품이 비치여부 및 상태",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "차량 운행 관련하여 안전관리 상태(하차 도우미 유무 등)",
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: "비상대피 시설관리가 양호한가",
              is_checked: "",
              note: "",
            },
            {
              id: 6,
              label: "그 밖의 실내외의 안전관리가 일별,월별 점검표에 의해 적절히 이행되고 있는지 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 7,
              label: "일별,월별 점검표가 의무기간동안 적절히 보관되고 있음(권장 1년이상 보관)",
              is_checked: "",
              note: "",
            },
            {
              id: 8,
              label: "일별,월별 점검결과에 따라 지체 없이 개선조치가 이행되고 있음",
              is_checked: "",
              note: "",
            },
          ],
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
